import React, { useEffect, useState } from "react";
import history from "../../history";
import { Row, Col, Card, CardBody } from "reactstrap";

import { Tabs, Tab } from "react-bootstrap";
import { fetchQueryParams } from "../../utils/comman";
import CartTitle from "../CartTitle";
import EventMainDetail from "../EventMainDetail";
import JoinUserList from "../JoinRideUserList";
import JoinUser from "../JoinUsers";

import get from "lodash/get";

const _ = { get };

const initialState = {
  formId: "",
  status: "PENDING",
  rejectionReason: "",
  toggleRejectModal: false,
  key: "event-detail",
  displayName: "Admin",
  eventStatus: "COMPLETED",
};

function eventDetail(props) {
  let { elements } = props;
  const [state, setState] = useState(initialState);

  useEffect(() => {
    if (props.selectedId) {
      props.handleFetchSingleEvent(props.selectedId);
    }
  }, [props.selectedId]);

  const handleSelectTab = (tab) => {
    state.key = tab;
    setState({ ...state });
    const params = fetchQueryParams(props.query);

    if (tab === "event-detail") {
      props.handleFetchSingleEvent(props.selectedId);
    } else {
      let data = {
        status: state.status,
        id: props.selectedId,
      };
      props.handleUsersForJoinEvent(data);
    }
    props.handleClearPreviousReducer();
  };

  useEffect(() => {
    let newState = { ...state };
    newState.key = "event-detail";
    setState(newState);
  }, []);

  console.log("tab", state.key);

  return (
    <React.Fragment>
      <div className="hideSearch">
        <Row>
          <Col sm={12}>
            <CartTitle
              title={_.get(
                elements,
                "eventDetailElement.headingElement",
                "Event Details"
              )}
              customClass={"hidebtn"}
              innerTextClass={"hidetext"}
              iconClass={"hideexcel"}
            />
          </Col>
        </Row>

        <Card className="mb-3">
          <CardBody className="px-0 px-lg-1 py-0 py-lg-1">
            <Row className="custom-tab">
              <Col sm={12}>
                <Tabs
                  id="tab-id"
                  activeKey={state.key}
                  onSelect={(k) => handleSelectTab(k)}
                >
                  <Tab
                    eventKey="event-detail"
                    title={_.get(
                      elements,
                      "eventDetailElement.tabDetailElement",
                      "Detail"
                    )}
                  >
                    <EventMainDetail
                      page={props.page}
                      query={props.query}
                      eventStatus={state.eventStatus}
                      displayName={state.displayName}
                      singleEvent={props.singleEvent}
                      handleFetchSingleEvent={props.handleFetchSingleEvent}
                      singleEventStatus={props.singleEventStatus}
                      handleEventModeration={props.handleEventModeration}
                      handleEventGallery={props.handleEventGallery}
                      elements={props.elements}
                      moderateEventGalleryStatus={
                        props.moderateEventGalleryStatus
                      }
                      selectedId={props.selectedId}
                      tab={state.key}
                      status={props.status}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  <Tab
                    eventKey="join-event"
                    title={_.get(
                      elements,
                      "eventDetailElement.tabJoinEventElement",
                      "All Applicants"
                    )}
                    disabled={
                      props.singleEvent !== null
                        ? props.singleEvent.moderationStatus !== "PENDING" &&
                          props.singleEvent.moderationStatus !== "REJECTED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <JoinUserList
                      formId={state.formId}
                      elements={props.elements}
                      allUser={props.allUser}
                      allUserStatus={props.allUserStatus}
                      handleUsersForJoinRide={props.handleUsersForJoinEvent}
                      usersToJoinRideStatus={props.usersToJoinEventStatus}
                      usersToJoinRide={props.usersToJoinEvent}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinEvent
                      }
                      handleFetchAllUser={props.handleFetchAllUser}
                      moderationStatusForUser={props.moderationStatusForUser}
                      singleRide={props.singleEvent}
                      query={props.query}
                      tab={state.key}
                      selectedId={props.selectedId}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  <Tab
                    eventKey="add-user-event"
                    title={_.get(
                      elements,
                      "eventDetailElement.addUserElement",
                      "Add Participant"
                    )}
                    disabled={
                      props.singleEvent !== null
                        ? props.singleEvent.moderationStatus !== "PENDING" &&
                          props.singleEvent.moderationStatus !== "REJECTED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <JoinUser
                      formId={state.formId}
                      elements={props.elements}
                      allUser={props.allUser}
                      allUserStatus={props.allUserStatus}
                      handleClearPreviousReducer={
                        props.handleClearPreviousReducer
                      }
                      handleUsersForJoinRide={props.handleUsersForJoinEvent}
                      usersToJoinRideStatus={props.usersToJoinEventStatus}
                      usersToJoinRide={props.usersToJoinEvent}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinEvent
                      }
                      handleJoinUser={props.handleJoinUser}
                      handleFetchAllUser={props.handleFetchAllUser}
                      moderationStatusForUser={props.moderationStatusForUser}
                      singleRide={props.singleEvent}
                      query={props.query}
                      selectedId={props.selectedId}
                      tab={state.key}
                      handleToggleModel={props.handleToggleModel}
                    />
                  </Tab>
                  {/* <Tab
                    eventKey="image-moderation"
                    title={_.get(
                      elements,
                      "rideDetailElement.imageModerationElement",
                      "Image Moderation"
                    )}
                    disabled={
                      props.singleEvent !== null
                        ? props.singleEvent.moderationStatus !== "PENDING" &&
                          props.singleEvent.moderationStatus !== "REJECTED" &&
                          props.singleEvent.eventStatus !== "COMPLETED"
                          ? false
                          : true
                        : null
                    }
                  >
                    <ImageModeration
                      elements={props.elements}
                      handleFetchAllUser={props.handleFetchAllUser}
                      handleClearPreviousReducer={
                        props.handleClearPreviousReducer
                      }
                      allUserStatus={props.allUserStatus}
                      allUser={props.allUser}
                      handleUsersForJoinRide={props.handleUsersForJoinRide}
                      usersToJoinRideStatus={props.usersToJoinRideStatus}
                      usersToJoinRide={props.usersToJoinRide}
                      handleUsersModerationForJoinRide={
                        props.handleUsersModerationForJoinRide
                      }
                      handleJoinUser={props.handleJoinUser}
                      singleRide={props.singleRide}
                      moderationStatusForUser={props.moderationStatusForUser}
                      query={props.query}
                    />
                  </Tab> */}
                </Tabs>
              </Col>
            </Row>
          </CardBody>
        </Card>
      </div>
    </React.Fragment>
  );
}

export default eventDetail;
